









































import { Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() appid!: string;

  templates = [];

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "你确定要上传代码吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const ver :any = this.templates.find((o:any,i)=>o.template_id==fieldValues.template_id)
            const res = await this.$store.dispatch("oplatformapps/commit", {
              appid: this.appid,
              template_id: fieldValues.template_id,
              user_version: ver && ver.user_version || "1.2.3",
              user_desc: fieldValues.user_desc || '羽约订场'
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  async loadTemplate() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("oplatformapps/gettemplatelist", {});
    if (res && res.Data) {
      this.templates = res.Data;
    }

    this.spinLoading = false;
  }

  mounted() {
    this.loadTemplate();
  }
}
